import React, { useState } from "react";

/**
 * Renderizza il logo del brand con fallback intelligente:
 * - Se logo_url è vuoto → mostra testo (tenant.name)
 * - Se logo_url dà 404 in caricamento → cade automaticamente sul testo
 *
 * Sostituisce il pattern `brand.logo_url ? <img/> : <text/>` che non gestisce
 * il caso di URL rotta (comune con storage effimero).
 */
export default function BrandLogo({
  logoUrl,
  fallbackText,
  className = "h-8",
  imgClassName = "",
  textClassName = "font-heading font-bold text-base",
  resolveUrl = (u) => u,
  invert = false,
  dataTestid,
}) {
  const [broken, setBroken] = useState(false);

  const shouldShowImage = logoUrl && !broken;

  if (shouldShowImage) {
    return (
      <img
        src={resolveUrl(logoUrl)}
        alt={fallbackText || "Logo"}
        className={`${className} ${imgClassName} ${invert ? "brightness-0 invert" : ""}`}
        onError={() => setBroken(true)}
        data-testid={dataTestid}
      />
    );
  }
  return (
    <div className={textClassName} data-testid={dataTestid}>
      {fallbackText || "—"}
    </div>
  );
}
